import React, {PropTypes, Component} from 'react';
import {
		View, Pages, Page, Views, Link, Toolbar
} from 'framework7-react';
import {getFramework7} from './App';
import {About} from '../components/pages/About';
import {ToursList} from '../components/pages/ToursList';
import {MapPage} from '../components/pages/Map';
import {BuildingDetailPopup} from './BuildingDetailPopup';
import Search from './pages/Search';
import axios from 'axios';

import {IAF_ICON} from './EncodedIAFIcons';

export default class MainViews extends Component {
	constructor(props, context) {
		super(props, context);

        this.state = {
            buildings: [],
			tours: [],
			architects: [],
            activeRoute: '#map',
			activeTour: null
        };
        var _this = this;
        axios.get('https://www.iowaarchfoundation.org/wp-json/appData?r=' + Date.now()).then(res => {
            _this.setState(prevState => ({
                buildings: res.data.buildings,
				tours: res.data.tours,
				architects: res.data.architects,
				config: res.data.config,
				remoteContent: res.data.pages,
            }));

			// preload the building images
			res.data.buildings.forEach((b) => (new Image).src = b.image);
        }).catch(function(_) {
            // alert('Unable to Reach IAF Server. Please check your connection.');
        });

		this.openMap = this.openMap.bind(this);
		this.openTour = this.openTour.bind(this);
		this.setTour = this.setTour.bind(this);
	}

	onClick(route) {
		this.setState({
			activeRoute: route
		});
	}

	getLinkClass(route) {
		return (route === this.state.activeRoute ? 'active' : '');
	}

	setTour(tour) {
		this.setState({
			activeTour: tour
		});
	}

	openTour() {
		getFramework7().mainView.router.loadPage("#tour");
		this.setState({
			activeRoute: "#tour"
		});
	}

	openMap() {
		getFramework7().mainView.router.loadPage("#map");
		this.setState({
			activeRoute: "#map"
		});
	}

	getBuildingForSlug = (buildingSlug) =>
		this.state.buildings.find((b) => b.slug === buildingSlug);

	render() {
		let popups = [];
		this.state.buildings.forEach(function (building)
		{
			popups.push(<BuildingDetailPopup key={building.slug} building={building} slug={'popup-' + building.slug} />);
		});


		var mapBuildings = [];
		if (this.state.activeTour != null) {

			this.state.activeTour.buildings.forEach((buildingSlug) =>
				mapBuildings.push(this.getBuildingForSlug(buildingSlug))
			);

		} else {
			mapBuildings = this.state.buildings;
		}

        let aboutIcon = '#about' === this.state.activeRoute ? IAF_ICON.ACTIVE : IAF_ICON.INACTIVE;

		return (<Views>
			<View name="home" main url="/">
				{/* Navbar */}
				{this.context.framework7AppContext.theme.ios ? (
						<Toolbar className="tabbar tabbar-labels">
							<Link href="#map" iconF7="compass_fill"
								  onClick={(event)=>this.onClick('#map')}
								  className={this.getLinkClass('#map')}>Explore</Link>
							<Link href="#tour" iconF7="navigation_fill"
								  onClick={(event)=>this.onClick('#tour')}
								  className={this.getLinkClass('#tour')}>Tours</Link>
							<Link iconF7="search_fill" href="#search"
								  onClick={(event)=>this.onClick('#search')}
								  className={this.getLinkClass('#search')}>Buildings</Link>
                            <Link href="#about"
                                  onClick={(event) => this.onClick('#about')}
                                  className={this.getLinkClass('#about')}>
                                <img src={aboutIcon}
									 alt="About Icon"
									 role="presentation"
									 className="about-toolbar-icon" />
                                About</Link>
						</Toolbar>
				) : null}
				{/* Pages */}
				<Pages>
					<Page name="map" className="page-on-center explore-page">
						<MapPage buildings={mapBuildings} tour={this.state.activeTour} config={this.state.config} openTour={this.openTour} cancelTour={() => {this.setTour(null);}}/>
					</Page>
					<Page className="about-page" name="about" cached="true">
						<About content={this.state.remoteContent !== undefined ? this.state.remoteContent.about : null}/>
					</Page>
					<Page name="tour" cached="true">
						<ToursList tour={this.state.activeTour} buildings={this.state.buildings} tours={this.state.tours} openMap={this.openMap} setTour={this.setTour}/>
					</Page>
					<Page className="search-page" name="search" cached="true">
						<Search buildings={this.state.buildings}/>
					</Page>
				</Pages>
			</View>
			<div>
				{popups}
			</div>
		</Views>
		);
	}
}

MainViews.contextTypes = {
	framework7AppContext: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/MainViews.jsx